import React, { useState, useEffect, useRef } from 'react';
import { Search } from 'lucide-react';
import { navItems } from './NavLinksData';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { CartButton } from '../../../../ui/elements/CartButton';
import PublicProfileMenu from './PublicProfileMenu';

const DesktopNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showSearch, setShowSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const searchRef = useRef<HTMLDivElement>(null);

  // Fermer le popup si on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setShowSearch(false);
        setSearchTerm('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // ✅ Clic sur le bouton Search → redirection directe vers /products
  const handleSearchClick = () => {
    setShowSearch(false);
    setSearchTerm('');
    navigate('/products');
  };

  // ✅ Détecte si un lien est actif
  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <nav className="hidden md:flex items-center justify-between w-full">
      {/* Groupe des liens de navigation */}
      <div className="flex space-x-8 items-center bg-white/10 backdrop-blur-sm rounded-full px-3">
        {navItems.map((item) => {
          const active = isActive(item.to);
          return (
            <Link
              key={item.name}
              to={item.to}
              className={`py-2 transition-colors duration-200 ${
                active
                  ? 'text-accent font-semibold'
                  : 'hover:text-accent'
              }`}
            >
              {item.name}
            </Link>
          );
        })}
      </div>

      {/* Groupe du panier et recherche */}
      <div className="flex items-center gap-4">
        <div className="relative" ref={searchRef}>
          <button
            onClick={handleSearchClick}
            className="p-2 rounded-full bg-white/30 hover:bg-white/50 transition"
            aria-label="Rechercher des produits"
            title="Rechercher des produits"
          >
            <Search size={24} />
          </button>
        </div>
        <CartButton />
        <PublicProfileMenu />
      </div>
    </nav>
  );
};

export default DesktopNav;